module.exports = __webpack_public_path__ + "static/media/paperclip.92a7a6f0.svg";